<template>
	<div id="bigImage">
		<div class='main'>
			<div id="tabContent" style="height:900px;width:100%" class="tab-content">
				<!--按钮-->
				<div class="btnBox">
					<div class="list">
						<!-- 窗宽/窗位  -->
						<p @click="windowCenterWidth()" @touchstart="windowCenterWidth()" class="buttonP" title="窗宽/窗位">
							<img class="imgStyle" src="../../assets/images/icon/窗位.png" alt=""><br />
							窗宽/窗位
						</p>
						<!-- 固定窗宽、窗位视图 -->
						<el-dropdown class="buttonP" v-if="caseMsg.caseModality == 'CT'" @command="constantWCW">
							<span class="el-dropdown-link">
								<img class="imgStyle" src="../../assets/images/icon/固定窗口.png" alt=""><br />
								固定窗
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :key="wcw.val" v-for="wcw in wcws" :command="wcw.val">{{ wcw.text }}
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<p class="buttonB" v-if="caseMsg.caseModality != 'CT'">
							<img class="imgStyle" src="../../assets/images/icon/固定窗灰.png" alt=""><br />
							固定窗
						</p>
						<!-- 负片  -->
						<p @click="negative()" @touchstart="negative()" class="buttonP" title="负片">
							<img class="imgStyle" src="../../assets/images/icon/负片.png" alt=""><br />
							负片
						</p>
						<!-- 缩/放 -->
						<p @click="zoom()" @touchstart="zoom()" class="buttonP" title="缩/放">
							<img class="imgStyle" src="../../assets/images/icon/放大缩小.png" alt=""><br />
							缩/放
						</p>
						<!-- 放大镜 -->
						<p @click="magnifying()" @touchstart="magnifying()" class="buttonP" title="放大镜">
							<img class="imgStyle" src="../../assets/images/icon/放大镜.png" alt=""><br />
							放大镜
						</p>
						<!-- 移动 -->
						<p @click="move()" @touchstart="move()" class="buttonP" title="移动">
							<img class="imgStyle" src="../../assets/images/icon/移动.png" alt=""><br />
							移动
						</p>
						<!-- 重置 -->
						<p @click="restore()" @touchstart="restore()" class="buttonP" title="重置">
							<img class="imgStyle" src="../../assets/images/icon/重置.png" alt=""><br />
							重置
						</p>
					</div>
					<div class="list">
						<!-- 像素测量 -->
						<p @click="pixelMeasurement()" v-if='caseMsg.caseModality == "CT"' class="buttonP" title="CT值">
							<img class="imgStyle" src="../../assets/images/icon/像素测量.png" alt=""><br />
							CT值
						</p>
						<p v-if='caseMsg.caseModality != "CT"' class="buttonB">
							<img class="imgStyle" src="../../assets/images/icon/CT值.png" alt=""><br />
							CT值
						</p>

						<!-- 长度测量 -->
						<p @click="lengthMeasurement()" @touchstart="lengthMeasurement()" class="buttonP" title="长度测量">
							<img class="imgStyle" src="../../assets/images/icon/长度测量.png" alt=""><br />
							长度测量
						</p>

						<!-- 角度测量 -->
						<p @click="angleMeasurement()" @touchstart="angleMeasurement()" class="buttonP" title="角度测量">
							<img class="imgStyle" src="../../assets/images/icon/角度测量.png" alt=""><br />
							角度测量
						</p>

						<!-- 区域测量(圆形) -->
						<p @click="areaMeasurementRoundness()" @touchstart="areaMeasurementRoundness()" class="buttonP"
							title="区域测量(圆形)">
							<img class="imgStyle" src="../../assets/images/icon/圆型测量.png" alt=""><br />
							圆型测量
						</p>

						<!-- 区域测量(矩形) -->
						<p @click="areaMeasurementSquare()" @touchstart="areaMeasurementSquare()" class="buttonP"
							title="区域测量(矩形)">
							<img class="imgStyle" src="../../assets/images/icon/矩形测量.png" alt=""><br />
							矩形测量
						</p>

						<!-- 文字标注 -->
						<p @click="textAnnotation()" @touchstart="textAnnotation()" class="buttonP" title="文字标注">
							<img class="imgStyle" src="../../assets/images/icon/文字标注.png" alt=""><br />
							文字标注
						</p>

						<!-- 清除 -->
						<p @click="clearTool()" @touchstart="clearTool()" class="buttonP" title="清除">
							<img class="imgStyle" src="../../assets/images/icon/删除.png" alt=""><br />
							清除
						</p>
					</div>
					<div class="list">
						<!-- 上下翻转 -->
						<p @click="inverting()" @touchstart="inverting()" class="buttonP" title="上下翻转">
							<img class="imgStyle" src="../../assets/images/icon/上下翻转.png" alt=""><br />
							上下翻转
						</p>
						<!-- 左右翻转 -->
						<p @click="aboutReverse()" @touchstart="aboutReverse()" class="buttonP" title="左右翻转">
							<img class="imgStyle" src="../../assets/images/icon/左右翻转.png" alt=""><br />
							左右翻转
						</p>
						<!-- 90°旋转 -->
						<p @click="rotate90()" @touchstart="rotate90()" class="buttonP" title="90°旋转">
							<img class="imgStyle" src="../../assets/images/icon/顺时针90°旋转.png" alt=""><br />
							90°旋转
						</p>
						<!-- 任意旋转 -->
						<p @click="rotateRandom()" @touchstart="rotateRandom()" class="buttonP" title="任意旋转">
							<img class="imgStyle" src="../../assets/images/icon/随意旋转.png" alt=""><br />
							任意旋转
						</p>
						<!-- 逐帧查看 -->
						<p @click="frameByFrame()" @touchstart="frameByFrame()" class="buttonP" title="逐帧查看">
							<img class="imgStyle" src="../../assets/images/icon/逐帧查看.png" alt=""><br />
							逐帧查看
						</p>
						<!-- 重置 -->
						<p @click="replacement()" @touchstart="replacement()" class="buttonP" title="重置">
							<img class="imgStyle" src="../../assets/images/icon/重置.png" alt=""><br />
							重置
						</p>
					</div>
					<div class="list">
						<!-- 播放 -->
						<p @click="dicomPlay()" @touchstart="dicomPlay()" class="buttonP" title="播放">
							<img class="imgStyle" src="../../assets/images/icon/播放.png" alt=""><br />
							播放
						</p>
						<!-- 暂停 -->
						<p @click="suspend()" @touchstart="suspend()" class="buttonP" title="暂停">
							<img class="imgStyle" src="../../assets/images/icon/暂停.png" alt=""><br />
							暂停
						</p>
						<!-- 大图查看 -->
						<p @click="bigDiag()" @touchstart="bigDiag()" class="buttonP" title="暂停">
							<img class="imgStyle" src="../../assets/images/icon/全屏.png" alt=""><br />
							大图查看
						</p>
						<!-- 加载进度 -->
						<span id="loadProgress" class="button" style="line-height:50px">0%</span>
					</div>

				</div>
				<!-- 图像部分 -->
				<div class="pictureBox" @mousewheel="handleMouseWheel"
					style="width:100%;height:100%;display:flex;justify-content:flex-start">
					<!--大图-->
					<div class="bigImgBox" :style="'width:100%;height:100%;padding:0 5px;box-sizing:border-box'">
						<div v-for="imageViewport in imageViewports" class="viewportWrapper cornerstone-enabled-image"
							:style="{ width: viewportWrapperWidth + '%', height: viewportWrapperHeight + '%' }"
							@contextmenu="returnFalse" unselectable='on' @selectstart='returnFalse'
							@mousedown='returnFalse'>

							<div v-show="!imageViewport.isShow" class="overlay overlay-text">Please drag a stack onto
								here to view images.</div>
							<div v-show="imageViewport.isShow" class="viewport" oncontextmenu="return false">
								<!-- 四角标注 -->
								<!-- 四角标注 -->
								<!-- 左上 -->
								<div class="setupViewportOverlays" style="top: 5px;left: 5px;text-align:left;font-size: 16px;">
									<div>{{ caseMsg.caseModality }}</div>
									<div>{{ imageViewport.Image }}</div>
									<!-- 扫描时间 -->
									<div>{{ imageViewport.scanTime }}</div>
								</div>
								<!-- 右上 -->
								<div class="setupViewportOverlays" style="top: 5px; right: 5px;text-align:right;font-size: 16px;">
									<div>{{ caseMsg.patientName }},{{ caseMsg.patientGender }},{{ caseMsg.patientAge }}</div>
									<!-- 部位 -->
									<!-- <div>{{imageViewport.port}}</div> -->
									<div>{{ caseMsg.belongHospName }}</div>
								</div>
								<!-- 左下 -->
								<div class="setupViewportOverlays" style="bottom: 10px; left: 5px;text-align:left;font-size: 16px;">
									<!-- 扫描序列 -->
									<div v-if="caseMsg.caseModality == 'MR'">{{ imageViewport.x00181030 }}</div>
									<!-- TR -->
									<div v-if="caseMsg.caseModality == 'MR'">{{ imageViewport.x00180080 }}</div>
									<!-- TE -->
									<div v-if="caseMsg.caseModality == 'MR'">{{ imageViewport.x00180081 }}</div>
									<!-- Field -->
									<div v-if="caseMsg.caseModality == 'MR'">{{ imageViewport.x00180087 }}</div>
									<!-- Flip Angle -->
									<div v-if="caseMsg.caseModality == 'MR'">{{ imageViewport.x00181314 }}</div>
									<!-- SL -->
									<div v-if="caseMsg.caseModality == 'CT'">{{ imageViewport.x00201041 }}</div>
									<!-- ST -->
									<div v-if="caseMsg.caseModality == 'CT'">{{ imageViewport.x00180050 }}</div>
									<!-- mA -->
									<div v-if="caseMsg.caseModality == 'CT'">{{ imageViewport.x00181151 }}</div>
									<!-- Kv -->
									<div v-if="caseMsg.caseModality == 'CT'">{{ imageViewport.x00180060 }}</div>
									<!-- 宽高 -->
									<div>{{ imageViewport.width }}</div>
								</div>
								<!-- 右下 -->
								<div class="setupViewportOverlays" style="bottom: 10px; right: 5px;text-align:right;font-size: 16px;">
									<!-- 曝光 时间 -->
									<div v-if="caseMsg.caseModality == 'CT'">{{ imageViewport.x00181150 }}</div>
									<!-- 缩放比 -->
									<div>{{ imageViewport.Zoom }}</div>
									<!-- ST -->
									<div v-if="caseMsg.caseModality == 'MR'">{{ imageViewport.x00180050 }}</div>
									<!-- SL -->
									<div v-if="caseMsg.caseModality == 'MR'">{{ imageViewport.x00201041 }}</div>
									<!-- DFOV -->
									<div v-if="caseMsg.caseModality == 'CT' || caseMsg.caseModality == 'MR'">
										{{ imageViewport.x00181100 }}</div>
									<div>{{ imageViewport.WWWL }}</div>
								</div>
								<!-- 左边 -->
								<div class="setupViewportOverlays" style="top: 50%;left: 5px;text-align:left;font-size: 26px;">
									<div v-if="islr==true">L</div>
									<div v-else>R</div>
								</div>
								<!-- 右边 -->
								<div class="setupViewportOverlays" style="top: 50%;right: 5px;text-align:left;font-size: 26px;">
									<div v-if="islr==true">R</div>
									<div v-else>L</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	mapState,
	mapActions
} from 'vuex'
import * as cornerstone from "../../../static/dist/cornerstone.js";
import * as dicomParser from "../../../static/dist/dicomParser.js"
import * as cornerstoneWADOImageLoader from "../../../static/dist/cornerstoneWADOImageLoader.js";
import Hammer from "../../../static/dist/hammer.js";
import * as cornerstoneMath from "../../../static/dist/cornerstoneMath.js";
import * as cornerstoneTools from "../../../static/dist/cornerstoneTools.js";
cornerstoneTools.external.Hammer = Hammer;
cornerstoneTools.external.cornerstone = cornerstone;
cornerstoneTools.external.cornerstoneMath = cornerstoneMath;
cornerstoneWADOImageLoader.external.cornerstoneMath = cornerstoneMath;
cornerstoneWADOImageLoader.external.dicomParser = dicomParser;
cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
cornerstone.registerImageLoader("http", cornerstoneWADOImageLoader.loadImage);
cornerstone.registerImageLoader("https", cornerstoneWADOImageLoader.loadImage);
//配置 webWorker (必须配置)
//注意这里的路径问题  如果路径不对 cornerstoneWADOImageLoaderWebWorker 会报错 index.html Uncaught SyntaxError: Unexpected token <
// var config = {
//   webWorkerPath: "../../../static/dist/cornerstoneWADOImageLoaderWebWorker.js",
//   taskConfiguration: {
//     decodeTask: {
//       codecsPath: "../../../static/dist/cornerstoneWADOImageLoaderCodecs.js"
//     }
//   }
// };
// cornerstoneWADOImageLoader.webWorkerManager.initialize(config);


export default {
	name: "bigImage",
	data() {
		return {
			islr:false,
			//窗宽窗位（一些固定值，根据片子类型，展示不同数据）
			wcws: [{
				text: '脑窗',
				val: '60.0_35.0'
			},
			{
				text: '骨窗',
				val: '1400.0_600.0'
			},
			{
				text: '纵膈窗',
				val: '350.0_0.0'
			},

			{
				text: '肺窗',
				val: '700.0_-600.0'
			},
			{
				text: '肝窗',
				val: '150.0_30.0'
			},
			{
				text: '腹窗',
				val: '250.0_40.0'
			},
			{
				text: '脊柱窗',
				val: '300.0_60.0'
			},
			{
				text: 'IAC',
				val: '2000.0_500.0'
			}
			],
			wcwval: '', //存储窗宽窗位的变量
			// baseUrl:"https://new-yingxiang.oss-cn-beijing.aliyuncs.com/",
			baseUrl: "https://yx.huayiyun.net/oss/",
			// baseUrl:"",
			isInitLoad: true, // ？？
			isShow: true,
			synchronizer: new cornerstoneTools.Synchronizer("cornerstonenewimage", cornerstoneTools
				.updateImageSynchronizer),
			layoutVal: '1x1', //选择的大图布局值
			//大图布局选项
			layouts: [{
				text: '1x1',
				val: '1x1'
			},
			{
				text: '1x2',
				val: '1x2'
			},
			{
				text: '1x3',
				val: '1x3'
			},
			{
				text: '2x1',
				val: '2x1'
			},
			{
				text: '2x2',
				val: '2x2'
			},
			{
				text: '2x3',
				val: '2x3'
			},
			{
				text: '3x1',
				val: '3x1'
			},
			{
				text: '3x2',
				val: '3x2'
			},
			{
				text: '3x3',
				val: '3x3'
			}
			],
			//影像片子序列
			imageViewports: [{
				isShow: true,
				isEnable: false,
				isSetupViewportOverlays: false,
				isLoadAndCacheImage: false
			}],
			//大图大小占比
			viewportWrapperWidth: 100,
			viewportWrapperHeight: 100,
			hospId: ''
		}
	},
	props: ['seriesList', 'caseMsg'],
	computed: {
		...mapState(['imageFlag'])
	},
	mounted() {
		setTimeout(() => {
			this.hospId = this.caseMsg.belongHospId
			this.seriesSelect(0);
		}, 1000)
		console.log('进来了')
		// this.initservice()

	},
	methods: {
		initservice(){
			console.log('navigatorxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
			console.log(navigator)
			if ('serviceWorker' in navigator) {
				console.log('Service Worker 能用:');
			navigator.serviceWorker
				.register('./service-worker.js')
				.then(registration => {
				console.log('Service Worker 注册成功:', registration);
				})
				.catch(error => {
				console.log('Service Worker 注册失败:', error);
				});
			}
		},
		handleMouseWheel(event) {
			// 处理鼠标滚轮事件的逻辑
			console.log('鼠标滚动了');
			console.log(this.caseMsg.caseModality)
			if (this.caseMsg.caseModality == "DR") {
				this.restore()
			}
		},
		returnFalse() {
			return false;
		},
		//选择序列
		seriesSelect(seriesNum) {
			console.log('大图显示');
			this.suspend(); //停止播放
			var _this = this;
			setTimeout(() => {
				//dom加载完成后，加载图像
				this.$nextTick(() => {
					// 找到要渲染的元素
					let canvass = document.getElementsByClassName("viewportWrapper");
					_this.imageViewports[0].isLoadAndCacheImage = false;

					//避免重复赋值，每次赋值结果一样
					if (!_this.imageViewports[0].canvas) {
						_this.imageViewports[0].canvas = canvass[0].getElementsByClassName("viewport")[
							0];
					}
					if (!_this.imageViewports[0].isEnable) {
						cornerstone.enable(_this.imageViewports[0].canvas);
						_this.imageViewports[0].isEnable = true;
					}
					if (!_this.imageViewports[0].isSetupViewportOverlays) {
						//四角标注
						_this.setupViewportOverlays(0)
						_this.imageViewports[0].isSetupViewportOverlays = true;
					}

					// 拼接 url : cornerstoneWADOImageLoader 需要 wadouri 路径头
					let imageIds = this.seriesList[0].instances;
					const imageUrl = this.baseUrl + this.seriesList[0].instances[0].dicomUrl;
					let imageId = "wadouri:" + imageUrl;

					//  下载图像并显示
					cornerstone.loadAndCacheImage(imageId).then(
						function (image) {
							// 设置元素视口
							let viewport = cornerstone.getDefaultViewportForImage(
								_this.imageViewports[0].canvas,
								image
							);
							if (_this.hospId == 'ba13995317bf4b63b97e7451fe17754d') {
								viewport.voiLUT = undefined;
							}
							_this.seriesList[0].instances = _this.framesJudge(image, imageIds,
								_this.seriesList[0].instances[0].dicomUrl, _this.seriesList[0]
									.instances[0].dicomId)
							// 激活工具(图像加载前)
							_this.initCanvasTools1(seriesNum, 0);
							// 显示图像
							cornerstone.displayImage(_this.imageViewports[0].canvas, image,
								viewport);
							// 激活工具(图像加载前)
							_this.initCanvasTools2(seriesNum, 0);
							// 图像是否加载完成
							if (!_this.imageViewports[0].isLoadAndCacheImage) {

								_this.imageViewports[0].isLoadAndCacheImage = true;
							}

						},
						function (err) {
							console.log('%c ' + err, 'color:red');
							console.log(err)
						}
					);
					// Dicom 加载 进度
					cornerstone.events.addEventListener(
						"cornerstoneimageloadprogress",
						function (event) {
							const eventData = event.detail;
							const loadProgress = document.getElementById("loadProgress");
							loadProgress.textContent = `Dicom加载: ${eventData.percentComplete
								}%`;
						}
					);
				})
			}, 100)

		},
		//图像加载前，初始化工具
		initCanvasTools1(num, num2) {
			let _self = this;
			let canvas = _self.imageViewports[num2].canvas;

			this.isInitLoad = false;
			// 为 canvasStack 找到 imageIds
			let allImageIds = [];
			this.seriesList[num].instances.forEach(function (imageId) {
				let imageUrl = "wadouri:" + _self.baseUrl + imageId.dicomUrl;
				allImageIds.push(imageUrl);
			});

			// Create canvasStack
			let canvasStack = {
				currentImageIdIndex: 0,
				imageIds: allImageIds
			};

			// Enable Inputs
			cornerstoneTools.mouseInput.enable(canvas);
			cornerstoneTools.mouseWheelInput.enable(canvas);
			cornerstoneTools.touchInput.enable(canvas);

			// Set the stack as tool state
			cornerstoneTools.addStackStateManager(canvas, ["stack"]);
			cornerstoneTools.addToolState(canvas, "stack", canvasStack);
		},
		//图像加载后，初始化工具
		initCanvasTools2(num, num2) {
			let _self = this;
			let canvas = _self.imageViewports[num2].canvas;
			// let csthumbnais = document.getElementsByClassName("csthumbnai");

			this.isInitLoad = false;


			cornerstoneTools.stackScrollWheel.activate(canvas); // Mouse wheel
			cornerstoneTools.scrollIndicator.enable(canvas); // Position indicator
			// Mouse
			cornerstoneTools.wwwc.activate(canvas, 1); // left click
			cornerstoneTools.pan.activate(canvas, 2); // middle click
			cornerstoneTools.zoom.activate(canvas, 4); // right click
			// Touch / Gesture
			cornerstoneTools.wwwcTouchDrag.activate(canvas); // - Drag
			cornerstoneTools.zoomTouchPinch.activate(canvas); // - Pinch
			cornerstoneTools.panMultiTouch.activate(canvas); // - Multi (x2)

			//参考线工具
			// _self.synchronizer.add(csthumbnais[0]);
			// cornerstoneTools.referenceLines.tool.enable(csthumbnais[0], _self.synchronizer);
			// _self.synchronizer.add(canvas);
			// cornerstoneTools.referenceLines.tool.enable(canvas, _self.synchronizer);

		},
		// Window Resize 监听窗口改变
		listenForWindowResize() {

			this.$nextTick(function () {
				window.addEventListener(
					"resize",
					this.debounce(this.onWindowResize, 100)
				);
			});
		},
		// 重新加载绘图区域大小
		onWindowResize() {
			for (var i = 0; i < this.imageViewports.length; i++) {
				if (this.imageViewports[i].isLoadAndCacheImage) {
					cornerstone.resize(this.imageViewports[i].canvas, true);
				}
			}
		},
		// Utility Methods (工具实用方法？？)
		debounce(func, wait, immediate) {
			var timeout;
			return function () {
				var context = this;
				var args = arguments;
				var later = function () {
					timeout = null;
					if (!immediate) func.apply(context, args);
				};
				var callNow = immediate && !timeout;
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (callNow) func.apply(context, args);
			};
		},
		// DICOM阅片
		forEachViewport(callback) {
			// console.log(this.imageViewports)
			for (var i = 0; i < this.imageViewports.length; i++) {
				if (this.imageViewports[i].isLoadAndCacheImage) {
					try {
						callback(this.imageViewports[i].canvas);
					} catch (e) {
						console.log("Debug:" + i)
						console.info(e);
					}
				}
			}
		},
		//初始化所有dicom工具(清除工具选择)
		disableAllTools() {
			window.sessionStorage.setItem('preventDefault', 0);
			try {
				this.forEachViewport(function (element) {
					cornerstoneTools.wwwc.disable(element);
					cornerstoneTools.pan.activate(element, 2); // 2 is middle mouse button
					cornerstoneTools.zoom.activate(element, 4); // 4 is right mouse button
					cornerstoneTools.probe.deactivate(element, 1);
					cornerstoneTools.length.deactivate(element, 1);
					cornerstoneTools.simpleAngle.deactivate(element, 1);
					cornerstoneTools.ellipticalRoi.deactivate(element, 1);
					cornerstoneTools.rectangleRoi.deactivate(element, 1);
					cornerstoneTools.stackScroll.deactivate(element, 1);
					cornerstoneTools.wwwcTouchDrag.deactivate(element);
					cornerstoneTools.zoomTouchDrag.deactivate(element);
					cornerstoneTools.panTouchDrag.deactivate(element);
					cornerstoneTools.stackScrollTouchDrag.deactivate(element);
					cornerstoneTools.rotate.disable(element);
					cornerstoneTools.magnify.disable(element);

					cornerstoneTools.magnifyTouchDrag.disable(element);
					cornerstoneTools.rotateTouchDrag.disable(element);
					cornerstoneTools.panTouchDrag.deactivate(element);
					cornerstoneTools.rotateTouchDrag.deactivate(element);
					cornerstoneTools.rotateTouch.disable(element);
					cornerstoneTools.ellipticalRoiTouch.deactivate(element);
					cornerstoneTools.angleTouch.deactivate(element);
					cornerstoneTools.rectangleRoiTouch.deactivate(element);
					cornerstoneTools.lengthTouch.deactivate(element);
					cornerstoneTools.probeTouch.deactivate(element);
					cornerstoneTools.zoomTouchDrag.deactivate(element);
					cornerstoneTools.wwwcTouchDrag.deactivate(element);
					cornerstoneTools.stackScrollTouchDrag.deactivate(element);

					cornerstoneTools.arrowAnnotate.deactivate(element);
					cornerstoneTools.arrowAnnotateTouch.deactivate(element);

				});

			} catch (err) {
				console.info("Error name: " + err.name + "");
				console.info("Error message: " + err.message);
			}

		},
		//布局 1x1\1x2\1x3...(根据选项，重新布局大图页面)
		changeLayout() {
			var that = this;
			var s = this.layoutVal.split(/x/);
			var ab = [parseInt(s[0]), parseInt(s[1])],
				a = ab[0],
				b = ab[1],
				numOfViewports = a * b,
				perWidth = 100 / b,
				perHeight = 100 / a;
			//数组增
			if (numOfViewports > this.imageViewports.length) {
				for (var i = this.imageViewports.length; i < numOfViewports; i++) {
					var obj = {
						isShow: false,
						isEnable: false,
						isSetupViewportOverlays: false,
						isLoadAndCacheImage: false
					}
					this.imageViewports.push(obj)
				}
			}
			//数组减
			else if (numOfViewports < this.imageViewports.length) {
				this.imageViewports = this.imageViewports.slice(0, numOfViewports);
			}
			//重新布局(改变每个大图框的大小)
			this.viewportWrapperWidth = perWidth;
			this.viewportWrapperHeight = perHeight;
			this.$nextTick(() => {
				//目前因为 使用 v-if 是否展示viewport，所以viewport第一次会不加载
				// var elementsByClassName = document.getElementsByClassName("viewport");
				// for (var i = 0; i < elementsByClassName.length; i++) {
				//   cornerstone.enable(elementsByClassName[i]);
				// }
				that.onWindowResize();
			})
		},
		// 四角标注
		setupViewportOverlays(num) {
			var _this = this;
			

			let canvas = document.getElementsByClassName("viewport")[num];
			_this.imageViewports[num].canvas = canvas;

			// On new image (displayed?)
			function onNewImage(event) {
				const eventData = event.detail;
				// CT mA - kV
				switch (eventData.image.data.string("x00080060")) {

					case "CT":

						var mA = eventData.image.data.string("x00181151");
						var kV = eventData.image.data.string("x00180060");
						var cH = eventData.image.data.string("x00180050"); //获取层厚 （还需确认这个值是否是层厚）
						var sL = eventData.image.data.string("x00201041");
						var time = eventData.image.data.string('x00181150'); //曝光时间

						if (mA !== undefined && mA !== null && mA !== "") {
							// $(bottomRightSpan[0]).html(eventData.image.data.string("x00181151")+"mA");
							// console.log(eventData.image.data.string("x00181151") + "mA");
							_this.imageViewports[num].x00181151 = '管电流:' + eventData.image.data.string("x00181151") +
								"mA";
						} else {
							_this.imageViewports[num].x00181151 = "";
						}
						if (kV !== undefined && kV !== null && kV !== "") {
							// $(bottomRightSpan[1]).html(eventData.image.data.string("x00180060")+"kV");
							// console.log(eventData.image.data.string("x00180060") + "kV");
							_this.imageViewports[num].x00180060 = '管电压:' + eventData.image.data.string("x00180060") +
								"kV";
						} else {
							// $(bottomRightSpan[1]).html("");
							_this.imageViewports[num].x00180060 = "";
						}
						if (cH !== undefined && cH !== null && cH !== "") {
							// console.log(eventData.image.data.string("x00180050") + "层厚");
							_this.imageViewports[num].x00180050 = '层厚:' + eventData.image.data.string("x00180050") +
								"mm";
						} else {
							_this.imageViewports[num].x00180050 = "";
						}
						if (sL !== undefined && sL !== null && sL !== "") {
							_this.imageViewports[num].x00201041 = '位置:' + eventData.image.data.string("x00201041");
						} else {
							_this.imageViewports[num].x00201041 = "";
						}
						if (time !== undefined && time !== null && time !== "") {
							_this.imageViewports[num].x00181150 = eventData.image.data.string("x00181150") + 'ms';
						} else {
							_this.imageViewports[num].x00181150 = "";
						}

						break;
					default:
						break;
				}

				// If we are currently playing a clip then update the FPS
				// Get the state of the 'playClip tool'
				var playClipToolData = cornerstoneTools.getToolState(eventData.element, 'playClip');

				// If playing a clip ...
				if (playClipToolData !== undefined && playClipToolData.data.length > 0 && playClipToolData.data[0]
					.intervalId !== undefined && eventData.frameRate !== undefined) {

					// Update FPS
					_this.imageViewports[num].FPS = "FPS: " + Math.round(eventData.frameRate);

				} else {
					// Set FPS empty if not playing a clip
					if (_this.imageViewports[num].FPS && _this.imageViewports[num].FPS.length > 0) {
						_this.imageViewports[num].FPS = ""
					}
				}

				var toolData = cornerstoneTools.getToolState(eventData.element, 'stack');
				if (toolData === undefined || toolData.data === undefined || toolData.data.length === 0) {
					return;
				}
				var stack = toolData.data[0];

				// Update Image number overlay

				_this.imageViewports[num].Image = "Image # " + (stack.currentImageIdIndex + 1) + "/" + stack.imageIds
					.length;
				// Add a CornerstoneNewImage event listener on the 'element' (viewer) (?)
				eventData.element.onCornerstoneNewImage = onNewImage;

				//重新渲染页面
				_this.$forceUpdate();
			}

			// 图像初始化事件
			_this.imageViewports[num].canvas.addEventListener("cornerstonenewimage", onNewImage)


			// On image rendered
			function onImageRendered(event) {

				
				const eventData = event.detail;
				
				console.log('图像信息')
				// var dicomData = eventData.image.data.string('x00200037')
				var dicomData = eventData.image.data
				
				

				var photometricInterpretation = dicomData.string('x00080004'); // Photometric Interpretation
				var imageOrientation = dicomData.string('x00200037'); // Image Orientation
				// 判断Pixel Data的解释是否为成像方向
				var isPhotometricFFEP = photometricInterpretation === 'MONOCHROME2';
				var isImageOrientationFFS = imageOrientation === '1.0,0.0,0.0,0.0,1.0,0.0'; // FFS: Feet First Supine
			
				var islr =  isPhotometricFFEP && isImageOrientationFFS; //LR 还是RL
				this.islr = islr

				// Set zoom overlay text
				_this.imageViewports[num].Zoom = "缩放比:" + eventData.viewport.scale.toFixed(2);
				//宽高
				_this.imageViewports[num].width = "宽高:" + eventData.image.columns + '/' + eventData.image.rows
				// Set WW/WL overlay text
				_this.imageViewports[num].WWWL = "窗宽/窗位:" + Math.round(eventData.viewport.voi.windowWidth) + "/" + Math
					.round(eventData.viewport.voi.windowCenter);
				//扫描时间
				var date = eventData.image.data.string('x00080020')
				var time = eventData.image.data.string('x00080030');
				var data1 = date.substring(0, 4) + '-' + date.substring(4, 6) + '-' + date.substring(6, 8);
				var data2 = time.substring(0, 2) + ':' + time.substring(2, 4) + ':' + time.substring(4, 6);
				_this.imageViewports[num].scanTime = data1 + ' ' + data2
				//部位
				_this.imageViewports[num].port = eventData.image.data.string('x00180015')
				//扫描序列
				_this.imageViewports[num].x00181030 = eventData.image.data.string('x00181030');
				//TR
				var tr = eventData.image.data.string('x00180080');
				if (tr !== undefined && tr !== null && tr !== "") {
					_this.imageViewports[num].x00180080 = '重复时间:' + eventData.image.data.string('x00180080') + 'ms';
				} else {
					_this.imageViewports[num].x00180080 = ''
				}
				//TE
				var te = eventData.image.data.string('x00180081');
				if (te !== undefined && te !== null && te !== "") {
					_this.imageViewports[num].x00180081 = '回波时间:' + eventData.image.data.string('x00180081') + 'ms';
				} else {
					_this.imageViewports[num].x00180081 = ''
				}
				//field
				var field = eventData.image.data.string('x00180087');
				if (field !== undefined && field !== null && field !== "") {
					_this.imageViewports[num].x00180087 = '磁场强度:' + eventData.image.data.string('x00180087') + 'T';
				} else {
					_this.imageViewports[num].x00180087 = ''
				}

				//flip angle
				var flip = eventData.image.data.string('x00181314');
				if (flip !== undefined && flip !== null && flip !== "") {
					_this.imageViewports[num].x00181314 = '翻转角:' + eventData.image.data.string('x00181314') + '°';
				} else {
					_this.imageViewports[num].x00181314 = ''
				}

				//DFOV
				var dfov = eventData.image.data.string('x00181100');
				if (dfov !== undefined && dfov !== null && dfov !== "") {
					_this.imageViewports[num].x00181100 = '重建直径:' + eventData.image.data.string('x00181100');
				} else {
					_this.imageViewports[num].x00181100 = ''
				}


				// Add a CornerstoneImageRendered event listener on the 'element' (viewer) (?)
				eventData.element.onCornerstoneImageRendered = onImageRendered;
				//重新渲染页面
				_this.$forceUpdate();
			}
			// 图像改变事件
			_this.imageViewports[num].canvas.addEventListener("cornerstoneimagerendered", onImageRendered)

		},
		// 窗宽窗位
		windowCenterWidth() {
			this.disableAllTools(); //清除全部工具
			this.forEachViewport(function (element) {
				cornerstoneTools.wwwc.activate(element, 1);
				cornerstoneTools.wwwcTouchDrag.activate(element);
			});
		},
		// 根据传入参数，固定窗宽窗位
		constantWCW(fixationWWWS) {
			this.disableAllTools(); //清除全部工具
			this.forEachViewport(function (element) {
				var wcww = fixationWWWS.split("_"); //得到每个下拉选项 对应的 窗宽 窗位 数组
				var viewport = cornerstone.getViewport(element); //获取该DICOM图属性对象viewport
				viewport.voi.windowWidth = parseFloat(wcww[0]); //修改窗宽
				viewport.voi.windowCenter = parseFloat(wcww[1]); //修改窗位
				cornerstone.setViewport(element, viewport); //使用修改后的DICOM图属性对象
			});
		},
		// 负片
		negative() {
			this.disableAllTools(); //清除全部工具
			this.forEachViewport(function (element) {
				var viewport = cornerstone.getViewport(element);
				// Toggle invert
				if (viewport.invert === true) {
					viewport.invert = false;
				} else {
					viewport.invert = true;
				}
				cornerstone.setViewport(element, viewport);
			});
		},
		// 缩放
		zoom() {
			this.disableAllTools(); //清除全部工具
			this.forEachViewport(function (element) {
				cornerstoneTools.zoom.activate(element, 5); // 5 is right mouse button and left mouse button
				cornerstoneTools.zoomTouchDrag.activate(element);
			});
		},
		// 放大镜
		magnifying() {
			this.disableAllTools(); //清除全部工具

			this.forEachViewport(function (element) {
				// Enable all tools we want to use with this element
				cornerstoneTools.magnify.activate(element, 1);
				cornerstoneTools.magnifyTouchDrag.activate(element);
			});
		},
		// 移动
		move() {
			this.disableAllTools(); //清除全部工具
			this.forEachViewport(function (element) {
				cornerstoneTools.pan.activate(element, 1);
				cornerstoneTools.panTouchDrag.activate(element);
			});
		},
		// 还原图像位置
		restore() {
			this.disableAllTools(); //清除全部工具

			this.forEachViewport(function (element) {
				var enabledElement = cornerstone.getEnabledElement(element);
				var canvas = enabledElement["canvas"];
				var viewport = cornerstone.getDefaultViewport(canvas, enabledElement.image)
				cornerstone.setViewport(element, viewport);
			});
		},
		// 像素测量
		pixelMeasurement() {
			this.disableAllTools(); //清除全部工具
			this.forEachViewport(function (element) {
				cornerstoneTools.probe.activate(element, 1);
				cornerstoneTools.probeTouch.activate(element);
			});
		},
		// 长度测量
		lengthMeasurement() {
			this.disableAllTools(); //清除全部工具
			this.forEachViewport(function (element) {
				cornerstoneTools.length.activate(element, 1);
				cornerstoneTools.lengthTouch.activate(element);
			});
		},
		// 角度测量
		angleMeasurement() {
			this.disableAllTools(); //清除全部工具
			this.forEachViewport(function (element) {
				cornerstoneTools.angleTouch.activate(element);
				cornerstoneTools.simpleAngle.activate(element, 1);
			});
		},
		// 区域测量(圆形)
		areaMeasurementRoundness() {
			this.disableAllTools(); //清除全部工具
			this.forEachViewport(function (element) {
				cornerstoneTools.ellipticalRoi.activate(element, 1);
				cornerstoneTools.ellipticalRoiTouch.activate(element);
			});
		},
		// 区域测量(方形)
		areaMeasurementSquare() {
			this.disableAllTools(); //清除全部工具
			this.forEachViewport(function (element) {
				cornerstoneTools.rectangleRoi.activate(element, 1);
				cornerstoneTools.rectangleRoiTouch.activate(element);
			});
		},
		// 清除工具操作
		clearTool() {
			this.disableAllTools(); //清除全部工具
			this.forEachViewport(function (element) {
				var toolStateManager = cornerstoneTools.globalImageIdSpecificToolStateManager;
				// Note that this only works on ImageId-specific tool state managers (for now)
				toolStateManager.clear(element);
				cornerstone.updateImage(element);
			});
		},
		// 上下反转
		inverting() {
			this.disableAllTools(); //清除全部工具
			this.forEachViewport(function (element) {
				var viewport = cornerstone.getViewport(element);
				viewport.vflip = !viewport.vflip;
				cornerstone.setViewport(element, viewport);
			});
		},
		// 左右旋转
		aboutReverse() {
			this.disableAllTools(); //清除全部工具
			this.forEachViewport(function (element) {
				var viewport = cornerstone.getViewport(element);
				viewport.hflip = !viewport.hflip;
				cornerstone.setViewport(element, viewport);
			});
		},
		// 90度旋转
		rotate90() {
			this.disableAllTools(); //清除全部工具
			this.forEachViewport(function (element) {
				var viewport = cornerstone.getViewport(element);
				viewport.rotation += 90;
				cornerstone.setViewport(element, viewport);
			});
		},
		// 任意旋转
		rotateRandom() {
			this.disableAllTools(); //清除全部工具
			this.forEachViewport(function (element) {
				// Enable all tools we want to use with this element
				cornerstoneTools.rotate.activate(element, 1);
				cornerstoneTools.rotateTouchDrag.activate(element);
			});
		},
		// 逐帧查看
		frameByFrame() {
			this.disableAllTools(); //清除全部工具
			this.forEachViewport(function (element) {
				window.sessionStorage.setItem('preventDefault', 1);
				cornerstoneTools.stackScroll.activate(element, 1);
				cornerstoneTools.stackScrollTouchDrag.activate(element);
			});
		},
		// 重置
		replacement() {
			this.disableAllTools(); //清除全部工具

			this.forEachViewport(function (element) {
				var enabledElement = cornerstone.getEnabledElement(element);
				var canvas = enabledElement["canvas"];
				var viewport = cornerstone.getDefaultViewport(canvas, enabledElement.image)
				cornerstone.setViewport(element, viewport);
			});
		},
		// 播放
		dicomPlay() {
			this.disableAllTools(); //清除全部工具

			this.forEachViewport(function (element) {
				var stackState = cornerstoneTools.getToolState(element, 'stack');
				var frameRate = stackState.data[0].frameRate;
				// Play at a default 10 FPS if the framerate is not specified
				if (frameRate === undefined) {
					frameRate = 10;
				}
				cornerstoneTools.playClip(element, frameRate);
			});
		},
		// 暂停
		suspend() {
			this.disableAllTools(); //清除全部工具
			//停止播放
			this.forEachViewport(function (element) {
				cornerstoneTools.stopClip(element);
			});
		},
		// 文本标注
		textAnnotation() {
			this.disableAllTools(); //清除全部工具

			this.forEachViewport(function (element) {
				// Enable all tools we want to use with this element
				cornerstoneTools.arrowAnnotate.activate(element, 1);
				cornerstoneTools.arrowAnnotateTouch.activate(element);
			});
		},
		// 全屏
		fullScreen() {
			var viewport_1 = document.getElementsByClassName("viewportWrapper")[0];
			this.forEachViewport(function (element) {
				if (!document.fullscreenElement && !document.mozFullScreenElement &&
					!document.webkitFullscreenElement && !document.msFullscreenElement) {
					if (viewport_1.requestFullscreen) {
						viewport_1.requestFullscreen();
					} else if (viewport_1.msRequestFullscreen) {
						viewport_1.msRequestFullscreen();
					} else if (viewport_1.mozRequestFullScreen) {
						viewport_1.mozRequestFullScreen();
					} else if (viewport_1.webkitRequestFullscreen) {
						viewport_1.webkitRequestFullscreen();
					}
				}
			});
		},
		//大图查看
		bigDiag() {

			// this.$common.setStorage('seriesList',this.seriesList);
			// // this.$store.commit('setSeriesList', this.seriesList)
			// this.$common.setStorage('caseMsg',this.caseMsg);
			this.$common.setStorage('seriesList', this.seriesList);
			this.$common.setStorage('caseMsg', this.caseMsg);
			try {
				// this.$common.setStorage('seriesList',this.seriesList);
				// this.$common.setStorage('caseMsg',this.caseMsg);
			} catch (e) {
				//TODO handle the exception
			}


			let routeData = this.$router.resolve({
				path: '/bigImageDiag',
			});
			window.open(routeData.href, '_blank');
			// this.$router.push('/bigImageDiag')
		},
		//多帧处理
		framesJudge(image, imageIds, dicomUrl, dicomId) {
			// 显示图像
			try {
				if (image.data.elements.x52009230) {
					var perFrameFunctionalGroupsSequenceElm = image.data.elements.x52009230;
					if (perFrameFunctionalGroupsSequenceElm.items && perFrameFunctionalGroupsSequenceElm.items.length >
						0) {
						if (imageIds.length !== perFrameFunctionalGroupsSequenceElm.items.length) {
							if (perFrameFunctionalGroupsSequenceElm.items[perFrameFunctionalGroupsSequenceElm.items
								.length - 1].tag === "xfffee000") {
								var baseSeriesURL = dicomUrl;
								imageIds = [];
								var imageItem = imageIds[0]
								perFrameFunctionalGroupsSequenceElm.items.forEach(function (value, index) {
									let item = {
										...imageItem
									}
									item.dicomUrl = baseSeriesURL + "?frame=" + index
									item.dicomId = dicomId;
									imageIds.push(item);
								});
							} else { }
						}
					}
				}
			} catch (e) {
				// console.info(e.message);
			}
			return imageIds
		}
	},
	watch: {
		//监听渲染影像
		imageFlag(val) {
			console.log(val)
			if (val) {
				this.seriesSelect(0);
				this.$store.state.imageFlag = false;
			}
		}
	}
}
</script>

<style>
@import "../../../static/css/cornerstone.min.css";
@import "../../../static/css/viewmulti.css";

* {
	margin: 0;
	padding: 0
}

#bigImage {
	width: 100%;
	height: 1000px;
}

.image-canvas-wrapper {
	width: 100%;
	height: 100%;
	margin: 0 auto;
}

.image-canvas {
	width: 100%;
	height: 100%;
}


.viewportWrapper {
	position: relative;
	color: white;
	display: inline-block;
	background-color: black;
	background-color: rgba(14, 12, 12, 0.28)
}

.setupViewportOverlays {
	position: absolute;
	color: #e4ad00;
	font-size: 12px;
}

.selected {
	outline: 1px solid #e4ad00;
}

.bigImgBox {
	box-sizing: border-box;
}

.backColor {
	background-color: #000;
}

.btnBox {
	display: flex;
	justify-content: flex-start;
	flex-wrap: wrap;
}

.btnBox .list {
	background-color: #333333;
	border-radius: 8px;
	padding: 10px;
	margin: 5px 0;
	margin-left: 5px;
	display: flex;
	justify-content: flex-start;
}

.btnBox .list .buttonP {
	color: #fff;
	margin-left: 5px;
	cursor: pointer;
	font-size: 10px;
	text-align: center;
	width: 54px;
}

.btnBox .list .buttonB {
	color: #bbb;
	margin-left: 5px;
	font-size: 10px;
	text-align: center;
	width: 54px;
}

.btnBox .list .buttonSelect {
	color: #000;
	margin-left: 5px;
	cursor: pointer;
	font-size: 14px;
	border-radius: 6px;
	outline: none;
}

.btnBox .list .button {
	color: #fff;
	margin-left: 5px;
	font-size: 15px;
	outline: none;
}

.btnBox .list .buttonP:hover {
	color: #e4ad00;
}

.imgStyle {
	width: 30px;
	height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Viewm/bigImage.vue